import React from "react";

import { Field, getIn } from "formik";

import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  HStack,
  Text,
  Flex,
  Stack,
  Radio,
} from "@chakra-ui/react";

import { CustomInput } from "../CustomInput";

export const CustomInputWField = ({
  fieldName,
  label,
  placeholder,
  isDisabled,
  onChange,
  maxLength,
  mt,
  onDelete,
  historico,
  index,
  messageLength,
  setFieldValue,
  isSelected,
  escolas,
  handleRadioChange,
  height,
  whiteSpace,
  setIsFocused,
  setIsBlur,
}) => {
  const handleRadioClick = () => {
    handleRadioChange();
  };

  return (
    <Field name={fieldName}>
      {({ field, form }) => (
        <FormControl
          isInvalid={
            getIn(form.errors, fieldName) && getIn(form.touched, fieldName)
          }
          id={fieldName}
          mt={mt ? mt : "0px"}
        >
          <FormLabel
            color="#5F6377"
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            whiteSpace={whiteSpace && "nowrap"}
            htmlFor={fieldName}
          >
            <Flex gap={1}>
              {label} <Text color="#169499">{historico}</Text>
            </Flex>
          </FormLabel>
          <HStack display={"flex"} justifyContent={"space-between"}>
            <Flex
              alignItems={{ base: "start", md: "center" }}
              gap={{ base: 4, md: 10 }}
              w={"100%"}
              flexDirection={{
                base: "column",
                md: "row",
              }}
            >
              <CustomInput
                maxLength={maxLength}
                messageLength={messageLength}
                name={field.name}
                width={
                  onDelete && {
                    base: "100%",
                    md: "350px",
                    lg: "560px",
                    xl: "650px",
                  }
                }
                value={field.value}
                onChange={onChange ? onChange : field.onChange}
                placeholder={placeholder}
                isDisabled={isDisabled}
                height={height}
                {...(setIsFocused &&
                  setIsBlur && {
                    onFocus: () => setIsFocused(false),
                    onBlur: () => setIsBlur(false),
                  })}
              />
              {escolas && (
                <Stack direction="row">
                  <label style={{ whiteSpace: "nowrap" }}>
                    <Radio
                      borderColor={
                        form.errors.unidadesEscolares ===
                        "Selecione a escola atual."
                          ? "red"
                          : "inherit"
                      }
                      size="md"
                      name="radioGroup"
                      borderWidth="1px"
                      isChecked={isSelected}
                      onChange={handleRadioClick}
                    >
                      Escola Atual
                    </Radio>
                  </label>
                  {form.errors.unidadesEscolares ===
                    "Selecione a escola atual." && (
                    <Text mt={2} color="red" opacity={0.8} fontSize="12px">
                      Selecione a escola atual.
                    </Text>
                  )}
                </Stack>
              )}
            </Flex>
          </HStack>
          <FormErrorMessage>{getIn(form.errors, fieldName)}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
